module.exports = __webpack_public_path__ + "img/47.13b56853.jpg";